
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Courbevoie dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Courbevoie certifiée Google Partner, soutient les entreprises courbevoisiennes pour accroître leur visibilité en ligne et développer leur clientèle.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Courbevoie dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Courbevoie certifiée Google Partner, soutient les entreprises courbevoisiennes pour accroître leur visibilité en ligne et développer leur clientèle.",
        },
      ],
    };
  },
};
